import { inject, Injectable } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import { MonitoringService } from './monitoring.service';
import { InsightsAuthService } from './insights-auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppLoadService {
  private _authService = inject(AuthService);
  private _monitoringService = inject(MonitoringService);
  private _insightsAuthService = inject(InsightsAuthService);

  async initAll() {
    const insightsCallbackPath = new URL(environment.insightsOidc.redirectUri, globalThis.location.origin).pathname;
    await this._authService.login(globalThis.location.pathname !== insightsCallbackPath);
    this._monitoringService.setAuthenticatedUserContext(this._authService.user()?.userId ?? '');
    // Fire-and-forget: attempt silent Insights auth without blocking app bootstrap.
    void this._insightsAuthService.initSilent();
  }
}
